import React from 'react';
import { Link } from 'react-router-dom';
import './EssenceCard.css';

const EssenceCard = ({ id, name, location, gives, path }) => {
  return (
    <Link to={path} className="essence-card-link">
      <div className="essence-card">
        <div className="essence-number">{id}</div>
        <h3 className="essence-name">{name}</h3>
        <div className="essence-details">
          <div className="detail-item">
            <span className="detail-label">Plassering:</span>
            <span className="detail-value">{location}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Gir:</span>
            <span className="detail-value">{gives}</span>
          </div>
        </div>
        <div className="essence-decoration">
          <div className="essence-light"></div>
        </div>
      </div>
    </Link>
  );
};

export default EssenceCard;
